import { createGlobalStyle, css } from "styled-components";
import { colors } from "./colors";

export const GlobalStyles = createGlobalStyle`${css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-size: 16px;
    color: #${colors.monocromatic._100};
  }

  a,
  button {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
  }
`}`;
